import React from 'react';
import clsx from 'clsx';
import { Box, BoxContent } from '../box';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Info Block Component
 * @deprecated
 * @param children {React.ReactNode} Children for Info Block
 * @param boxed {boolean} Boxed block
 * @param onClick {Function} OnClick Event
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 */
const InfoBlock = ({ className, boxed, children, onClick, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    if (boxed) {
        return (React.createElement(Box, { onClick: onClick && onClick },
            React.createElement(BoxContent, null,
                React.createElement("div", { className: hashClass(styled, clsx('info-block', className)), ...others }, children))));
    }
    return (React.createElement("div", { "data-testid": testId, style: { padding: '2.5rem' } },
        React.createElement("div", { onClick: onClick && onClick, className: clsx('info-block', className), ...others }, children)));
};
export default InfoBlock;
//# sourceMappingURL=InfoBlock.js.map